export const globalStyle = {
  body: {
    bg: 'background.grey',
    color: 'text.dark.grey',
    fontSize: '14px'
  }
};